import { z } from 'zod';
import { bookmarkKindSchema } from '../enums';
import { isoDateTimeSchema, uuidSchema } from './common';

/**
 * `BookmarkDto` (PLAN §4 bookmarks bar, D-047). A leaf file because the conversation details
 * (`messaging.ts`) and the bookmark endpoints (`channel-extras.ts`) both use it.
 */
export const bookmarkDtoSchema = z.object({
  id: uuidSchema,
  conversationId: uuidSchema,
  kind: bookmarkKindSchema,
  title: z.string(),
  url: z.string().nullable(),
  fileId: uuidSchema.nullable(),
  messageId: uuidSchema.nullable(),
  emoji: z.string().nullable(),
  /** Fractional-index key (D-047). */
  position: z.string(),
  createdBy: uuidSchema,
  createdAt: isoDateTimeSchema,
});
export type BookmarkDto = z.infer<typeof bookmarkDtoSchema>;
